import * as React from 'react';
import * as hero from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
export const Screen1 = ({ sravni }) => {
  return (
    <section className={hero.hero}>
      <div className={'container'}>
        <HeaderLogoAndTel noLink={sravni} />
        <div className={hero.hero__info}>
          <span className={hero.hero__bage}>Онлайн-тренинг</span>
          <h1 className={hero.hero__title}>Любой иностранный за&nbsp;месяц</h1>
          <p className={hero.hero__text}>
            С&nbsp;нуля до&nbsp;разговора на&nbsp;бытовые темы с&nbsp;помощью методики преподавателя 4-х иностранных
            языков
          </p>
          <div className={hero.hero__btns}>
            <a className={`${hero.hero__btn} ${hero.hero__btnMain}`} href={'#reg'}>
              Оставить заявку
            </a>
            <a className={`${hero.hero__btn} ${hero.hero__btnSimple}`} href={'#program'}>
              Смотреть программу
            </a>
          </div>
          <picture className={hero.hero__img}>
            <source
              srcSet={'https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/bg-lubim-320.png'}
              media={'(max-width: 480px)'}
            />
            <img
              src="https://fs.advance.ru/landing-pages/course/lyuboy_inostrannyi_za_mesyac/bg-lubim-1920.png"
              alt={'Обложка'}
            />
          </picture>
          <ul className={hero.hero__details}>
            <li className={`${hero.hero__detailsItem} ${hero.hero__detailsItemOne}`}>
              Более 30&nbsp;часов
              <br />
              практики
            </li>
            <li className={`${hero.hero__detailsItem} ${hero.hero__detailsItemTwo}`}>
              7&nbsp;занятий
              <br />
              с&nbsp;домашними
              <br />
              заданиями
            </li>
            <li className={`${hero.hero__detailsItem} ${hero.hero__detailsItemThree}`}>
              Поддержка
              <br />
              преподавателя курса и&nbsp;кураторов 24/7
            </li>
            <li className={`${hero.hero__detailsItem} ${hero.hero__detailsItemFour}`}>
              Общий чат
              <br />
              учеников
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
